export default __webpack_public_path__ + "static/media/queen_of_wands.b2c7fcb6.png";